import { useThree } from "@react-three/fiber";
const useMap = () => useThree((s) => {
  var _a;
  return (_a = s.r3m) == null ? void 0 : _a.map;
});
export {
  useMap
};
//# sourceMappingURL=main2.mjs.map
